module.exports = __webpack_public_path__ + "static/media/job_openings.8a174036.jpg";